<template>
    <span class="material-icons" v-if="type === ActivityTypes.USER_STATUS_CHANGED.id"> local_cafe </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.BLOCK_VISITOR.id"> lock </span>
    <span class="material-icons text-success" v-else-if="type === ActivityTypes.UNBLOCK_VISITOR.id"> lock_open </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.USER_ADDED.id"> person_add </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHANNEL_CREATED.id"> add_box </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.CHANNEL_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHAT_OPENED.id"> chat </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHAT_CLOSED.id"> mark_chat_read </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WEBHOOK_ADDED.id"> webhook </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WEBHOOK_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TRIGGER_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.TRIGGER_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TRIGGER_UPDATED.id"> update </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.DEPARTMENT_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.DEPARTMENT_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.ROLE_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.ROLE_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TAGS_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.TAGS_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WELCOME_MESSAGE_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WELCOME_MESSAGE_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.BANNED_WORD_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.BANNED_WORD_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_CREATED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.SETTINGS_UPDATED.id"> settings </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.MAIL_ADDRESS_ADDED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.USER_ADDED_TO_DEPARTMENT.id"> update </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id">
        remove_circle
    </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_DELETED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id">
        update
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CONTENT_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.CONTENT_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_UPDATED.id"> update </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.CHAT_ASSIGNED_TO_USER.id"> maps_ugc </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.CHAT_FORWARDED_TO_USER.id">
        phone_forwarded
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.USER_JOINED_TO_CHAT.id"> shortcut </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.USER_LOGGED_IN.id"> login </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.TICKET_ASSIGNED_TO_USER.id">
        assignment_ind
    </span>

    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_CREATED.id">
        cell_tower
    </span>
    <span class="material-icons text-warning" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id">
        cell_tower
    </span>
    <span class="material-icons text-success" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id">
        cell_tower
    </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_FAILED.id">
        cell_tower
    </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_DELETED.id">
        remove_circle
    </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.BILLING_ADDRESS_UPDATED.id"> update </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_CREATED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PLAN_STARTED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PLAN_CANCELED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_PAYMENT_RECEIVED.id"> paid </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_PAYMENT_FAILED.id">
        money_off_csred
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PAYMENT_METHOD_ADDED.id"> add_card </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_REFUNDED.id">
        assignment_return
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.LOGIN_FORM_ACTIVATED.id">
        format_indent_decrease
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.LOGIN_FORM_DEACTIVATED.id">
        format_indent_increase
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.LOGIN_FORM_UPDATED.id"> update </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.USER_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon text-dark" v-else-if="type === ActivityTypes.CONTACT_PROP_ADDED.id">
        add_circle
    </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.CONTACT_PROP_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_CREATED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_STAGE_CHANGED.id"> update </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_CREDIT_LOW.id"> expand_more </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREATED.id"> smart_toy </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREDIT_LOW.id"> report </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREDIT_DONE.id"> disc_full </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.SYSTEM_STATUS.id"> update </span>
    <span class="material-icons text-danger"
          v-else-if="type === ActivityTypes.CHATBOT_DELETED.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_PUBLISHED.id"> public </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ASSIGNED_TO_USER.id"> add_task </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id"> qr_code_scanner </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id"> qr_code_scanner </span>

</template>
<script>
import Vue from "vue";
import ActivityTypes from "../ActivityTypes";

export default Vue.extend({
    name: "ActivityIconViewer",
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ActivityTypes,
        };
    },
});
</script>

<style scoped lang="scss">
.material-icons {
    font-size: 20px;
    font-weight: 600;
}
</style>
